export class AuthConfig {
  clientId!: string;
  signUpSignIn!: B2CPolicyConfig;
  editProfile!: B2CPolicyConfig;
  passwordReset!: B2CPolicyConfig;
  registration!: B2CPolicyConfig;
  authorityDomain!: string;
  scopes!: string[];
  redirectUri?: string;
  postLogoutRedirectUri?: string;
  redirectStartPage?: string;

  constructor(init?: Partial<AuthConfig>) {
    Object.assign(this, init);
  }
}

export interface B2CPolicyConfig {
  authority: string,
  policyName: string
}
